var players = {}; // Store multiple YouTube players

document.addEventListener('shopify:section:load', () => {
    console.log('onYouTubeIframeAPIReady');
    onYouTubeIframeAPIReady();
});
// YouTube API Ready
function onYouTubeIframeAPIReady() {
    document.querySelectorAll('[id^="youtube-player"]').forEach(container => {
        let videoId = container.dataset.videoId;
        let playerId = container.id;
      
        console.log(players[playerId], videoId, 'players[playerId]');

        players[playerId] = new YT.Player(playerId, {
            videoId: videoId,
            playerVars: {
                autoplay: 1,
                controls: 1,
                mute: 1,
                rel: 0,
                loop: 1,
                playlist: videoId,
                showinfo: 0
            }
        });
    });

    attachMuteButtonListeners();
}

// Attach event listeners to mute buttons
function attachMuteButtonListeners() {
    document.querySelectorAll('.mute-button').forEach(button => {
        button.addEventListener('click', function () {
            let videoElement = this.parentElement.querySelector("video, iframe");
            if (!videoElement) return;

            let isMuted = this.dataset.muteStatus === 'true';
            this.dataset.muteStatus = isMuted ? 'false' : 'true';
            if (videoElement.tagName === 'VIDEO') {
                videoElement.muted = !isMuted;
                videoElement.volume = isMuted ? 1.0 : 0;
            } else if (videoElement.classList.contains('vimeo_player')) {
                let player = new Vimeo.Player(videoElement);
                player.setVolume(isMuted ? 1 : 0);
            } else {
                let player = players[this.dataset.playerId];
                if (player) isMuted ? player.unMute() : player.mute();
            }

            this.innerHTML = isMuted ? getUnmuteIcon() : getMuteIcon();
        });
    });
}

// SVG icons
function getMuteIcon() {
    return `<path d="M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zM7.84 6.05c0-.435-.252-.54-.56-.232L5.16 7.94H3.704a.794.794 0 0 0-.791.793v1.686a.794.794 0 0 0 .791.792h1.457l2.12 2.12c.308.308.56.204.56-.232zm3.84 3.524 1.49-1.49a.396.396 0 0 0-.56-.56l-1.49 1.49-1.49-1.49a.396.396 0 0 0-.56.56l1.49 1.49-1.49 1.49a.396.396 0 1 0 .56.56l1.49-1.49 1.49 1.49a.396.396 0 0 0 .56-.56z"/>`;
}

function getUnmuteIcon() {
    return `<path d="M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zM7.84 6.06c0-.435-.252-.54-.56-.231l-2.12 2.12H3.704a.794.794 0 0 0-.791.792v1.686a.794.794 0 0 0 .791.792h1.457l2.12 2.12c.308.308.56.204.56-.231zm1.792 5.337a2.564 2.564 0 0 0 0-3.626.396.396 0 1 0-.56.56 1.773 1.773 0 0 1 0 2.506.396.396 0 1 0 .56.56zm2.597-1.813a4.38 4.38 0 0 0-1.292-3.118.396.396 0 0 0-.56.56 3.618 3.618 0 0 1 0 5.116.396.396 0 1 0 .56.56 4.38 4.38 0 0 0 1.292-3.118z"/>`;
}
